<!-- {{courseStructureData | json}} -->
<div class="flex items-center gap-2">
    <button class="btn btn-sm btn-neutral" [disabled]="isAddingChapter" (click)="addChapter()">
        @if(isAddingChapter){<i class="ri-loader-4-line animate-spin"></i>}
        @else{<i class="ri-add-line"></i>}
        Add Chapter
    </button>
    <a (click)="nextTab()" class="btn btn-sm bg-white capitalize border">next <i class="ri-arrow-right-line"></i></a>
</div>

<div class="mt-5">

    <ul class="my-3 flex flex-col gap-5" cdkDropList [cdkDropListData]="courseStructureData"
        (cdkDropListDropped)="parentDrop($event)">


        <!-- <pre>{{ (courseStructure$ | async) | json }}</pre> -->

        @for (parent of courseStructureData || [] ; let parentIndex = $index; track $index) {
        <li class="main_node" [ngClass]="{'new':parent?.flag === 1}" cdkDrag>
            <div class=" flex gap-3 items-center">
                <button class="btn btn-xs btn-circle bg-white" [disabled]="parent?.flag === 1"
                    (click)="toggleNode(1,1,parentIndex,null,null,null,'visible')"><i
                        class="ri-arrow-drop-down-line"></i></button>
                <div class="inline-flex items-center gap-2 bg-white p-2 rounded-lg">
                    <div class="w-52">
                        <input type="text" id="parent_input_{{parent.id}}" placeholder="Chapter Name"
                            [value]="parent?.structure_name"
                            class="input input-sm bg-zinc-100 capitalize disabled:bg-white disabled:text-black disabled:font-semibold max-w-full"
                            [disabled]="!parent?.isEditing" maxlength="255" />
                        <div id="error_parent_input_{{parent.id}}" class="mt-1 hidden text-xs text-red-500"></div>
                    </div>


                    @if (parent?.isEditing) {
                    <button class="btn btn-sm btn-circle bg-white text-green-600"
                        (click)="saveNode('parent_input_' + parent.id,0,parent.flag,parent.id)" [disabled]="isNodeSaving(parent.id)">
                        @if (isNodeSaving(parent.id)) {<i class="ri-loader-4-line animate-spin"></i>}@else{<i class="ri-check-line"></i>}
                    </button>

                    @if(parent?.flag === 1) {
                    <button class="btn btn-sm btn-circle bg-white text-red-600"
                        (click)="deleteNewNode(1,parent.id,parentIndex)"><i class="ri-delete-bin-7-line"></i></button>
                    }@else {
                    <button class="btn btn-sm btn-circle bg-white text-zinc-600"
                        (click)="toggleNode(1,1,parentIndex,null,null,null,'edit','parent_input_'+parent.id,false)"><i
                            class="ri-close-line"></i></button>
                    }

                    }@else {
<button class="btn btn-sm btn-circle bg-white text-zinc-600"
                                        [disabled]="coursePublished"
                                        (click)="!coursePublished && toggleNode(1,1,parentIndex,null,null,null,'edit','parent_input_'+parent.id,true)"><i
                                            class="ri-pencil-fill"></i></button>
                    <button class="btn btn-sm btn-circle bg-white text-red-600" 
                                        [disabled]="coursePublished"
                                        (click)="!coursePublished && deleteNode(parent.id)"><i
                            class="ri-delete-bin-7-line"></i></button>
                    }

                    <span class="divider divider-horizontal m-0 p-0"></span>
                    <span class="cursor-grab" cdkDragHandle><i class="ri-draggable"></i></span>
                </div>
            </div>

            @if (parent?.isOpen) {
            <div class="content">
                <div class="" [ngClass]="{'min-h-[5rem]':parent?.flag !== 1}">
                    <ul class=" my-3 flex flex-col gap-5" cdkDropList [cdkDropListData]="parent?.child || []"
                        (cdkDropListDropped)="childDrop(parentIndex, $event)">

                        @for (child of parent?.child || [];let childIndex = $index ; track $index) {
                        <li class="child_node" [ngClass]="{'new':child?.flag === 1}" cdkDrag>

                            <div class=" flex gap-3 items-center">
                                <button class="btn btn-xs btn-circle bg-white" [disabled]="child?.flag === 1"
                                    (click)="toggleNode(1,2,parentIndex,childIndex,null,null,'visible')">
                                    <i class="ri-arrow-drop-down-line"></i></button>
                                <div class="inline-flex items-center gap-2 bg-white p-2 rounded-lg">
                                    <input type="text" placeholder="Topic Name" [value]="child?.structure_name"
                                        id="child_input_{{child.id}}"
                                        class="input input-sm bg-zinc-100 w-52 capitalize disabled:bg-white disabled:text-black disabled:font-semibold"
                                        [disabled]="!child?.isEditing" />
                                    <div id="error_child_input_{{child.id}}" class="mt-1 hidden text-xs text-red-500"></div>
                                    @if (child?.isEditing) {
                                    <button class="btn btn-sm btn-circle bg-white text-green-600"
                                        (click)="saveNode('child_input_' + child.id,child.parent_id,child.flag,child.id)" [disabled]="isNodeSaving(child.id)">
                                        @if (isNodeSaving(child.id)) {<i class="ri-loader-4-line animate-spin"></i>}@else{<i class="ri-check-line"></i>}
                                    </button>
                                    @if(child?.flag === 1) {
                                    <button class="btn btn-sm btn-circle bg-white text-red-600"
                                        (click)="deleteNewNode(2,child.id,parentIndex,childIndex)"><i
                                            class="ri-delete-bin-7-line"></i></button>
                                    }@else {
                                    <button class="btn btn-sm btn-circle bg-white text-zinc-600"
                                        (click)="toggleNode(1,2,parentIndex,childIndex,null,null,'edit','child_input_'+child.id,false)"><i
                                            class="ri-close-line"></i></button>
                                    }
                                    }@else {
                                    <button class="btn btn-sm btn-circle bg-white text-zinc-600"
                                        [disabled]="coursePublished"
                                        (click)="!coursePublished && toggleNode(1,2,parentIndex,childIndex,null,null,'edit','child_input_'+child.id,true)"><i
                                            class="ri-pencil-fill"></i></button>
                                    <button class="btn btn-sm btn-circle bg-white text-red-600"
                                        [disabled]="coursePublished"
                                        (click)="!coursePublished && deleteNode(child.id)"><i class="ri-delete-bin-7-line"></i></button>
                                    }

                                    <span class="divider divider-horizontal m-0 p-0"></span>
                                    <span class="cursor-grab" cdkDragHandle><i class="ri-draggable"></i></span>
                                </div>
                            </div>

                            @if (child?.isOpen) {
                            <div class="content">
                                <div [ngClass]="{'min-h-[5rem]':child?.flag !== 1}">
                                    <ul class=" my-3 flex flex-col gap-5" cdkDropList
                                        [cdkDropListData]="child?.grandChild || []"
                                        (cdkDropListDropped)="grandChildDrop(parentIndex, childIndex, $event)">

                                        @for (subchild of child?.grandChild || []; let subchildIndex = $index; track
                                        $index) {

                                        <li class="subchild_node" [ngClass]="{'new':subchild?.flag === 1}" cdkDrag>

                                            <div class=" flex gap-3 items-center">
                                                <button class="btn btn-xs btn-circle bg-white"
                                                    [disabled]="subchild?.flag === 1"
                                                    (click)="toggleNode(1,3,parentIndex,childIndex,subchildIndex,null,'visible')">
                                                    <i class="ri-arrow-drop-down-line"></i></button>
                                                <div class="inline-flex items-center gap-2 bg-white p-2 rounded-lg">
                                                    <input type="text" placeholder="Sub-Topic Name"
                                                        [value]="subchild?.structure_name"
                                                        id="subchild_input_{{subchild.id}}"
                                                        class="input input-sm bg-zinc-100 w-52 capitalize disabled:bg-white disabled:text-black disabled:font-semibold"
                                                        [disabled]="!subchild?.isEditing" />
                                                    <div id="error_subchild_input_{{subchild.id}}" class="mt-1 hidden text-xs text-red-500"></div>

                                                    @if (subchild?.isEditing) {
                                                    <button class="btn btn-sm btn-circle bg-white text-green-600"
                                                        (click)="saveNode('subchild_input_'+subchild.id,subchild.parent_id,subchild.flag,subchild.id)" [disabled]="isNodeSaving(subchild.id)">
                                                        @if (isNodeSaving(subchild.id)) {<i class="ri-loader-4-line animate-spin"></i>}@else{<i class="ri-check-line"></i>}
                                                    </button>
                                                    @if(subchild?.flag === 1) {
                                                    <button class="btn btn-sm btn-circle bg-white text-red-600"
                                                        (click)="deleteNewNode(3,subchild.id,parentIndex,childIndex,subchildIndex)"><i
                                                            class="ri-delete-bin-7-line"></i></button>
                                                    }@else {
                                                    <button class="btn btn-sm btn-circle bg-white text-zinc-600"
                                                        (click)="toggleNode(1,3,parentIndex,childIndex,subchildIndex,null,'edit','subchild_input_'+subchild.id,false)"><i
                                                            class="ri-close-line"></i></button>
                                                    }
                                                    }@else {
                                                    <button class="btn btn-sm btn-circle bg-white text-zinc-600"
                                                        [disabled]="coursePublished"
                                                        (click)="!coursePublished && toggleNode(1,3,parentIndex,childIndex,subchildIndex,null,'edit','subchild_input_'+subchild.id,true)"><i
                                                            class="ri-pencil-fill"></i></button>
                                                    <button class="btn btn-sm btn-circle bg-white text-red-600"
                                                        [disabled]="coursePublished"
                                                        (click)="!coursePublished && deleteNode(subchild.id)"><i
                                                            class="ri-delete-bin-7-line"></i></button>
                                                    }

                                                    <span class="divider divider-horizontal m-0 p-0"></span>
                                                    <span class="cursor-grab" cdkDragHandle><i class="ri-draggable"></i></span>
                                                </div>
                                            </div>
                                            @if (subchild?.isOpen) {
                                            <div class="content">
                                                <div [ngClass]="{'min-h-[2rem]':subchild?.flag !== 1}">
                                                    <ul class="my-3 flex flex-col gap-5 pl-9" cdkDropList
                                                        [cdkDropListData]="subchild?.structure_maps || []"
                                                        (cdkDropListDropped)="structureMapDrop('grandChild',{parentIndex,childIndex,grandChildIndex: subchildIndex}, $event)">

                                                        @if (subchild.structure_maps && isAllComponentsVisible) {
                                                        @for (structure_maps of subchild?.structure_maps;let
                                                        subchildStructureMapsIndex = $index; track $index)
                                                        {
                                                        <ng-container [ngSwitch]="structure_maps?.action_type">
                                                            <li *ngSwitchCase="'video'" cdkDrag>
                                                                <app-video-form (dataEvent)="emitData($event)"
                                                                    [data]="structure_maps"
                                                                    [coursePublished]="coursePublished"
                                                                    [index]="{'structureIndex':subchildStructureMapsIndex,'parentIndex':parentIndex,'childIndex':childIndex,'grandChildIndex':subchildIndex}"></app-video-form>
                                                            </li>
                                                            <li *ngSwitchCase="'document'" cdkDrag>
                                                                <app-document-form></app-document-form>
                                                            </li>
                                                            <li *ngSwitchCase="'certificate'" cdkDrag>
                                                                <app-certificate-form (dataEvent)="emitData($event)"
                                                                    [data]="structure_maps"
                                                                    [coursePublished]="coursePublished"
                                                                    [index]="{'structureIndex':subchildStructureMapsIndex,'parentIndex':parentIndex,'childIndex':childIndex,'grandChildIndex':subchildIndex}"></app-certificate-form>
                                                            </li>
                                                            <li *ngSwitchCase="'badge'" cdkDrag>
                                                                <app-badge-form (dataEvent)="emitData($event)"
                                                                    [data]="structure_maps"
                                                                    [coursePublished]="coursePublished"
                                                                    [index]="{'structureIndex':subchildStructureMapsIndex,'parentIndex':parentIndex,'childIndex':childIndex,'grandChildIndex':subchildIndex}"></app-badge-form>
                                                            </li>

                                                        </ng-container>
                                                        }
                                                        }

                                                    </ul>
                                                </div>

                                                @if (subchild?.flag !== 1) {

                                                <div class="flex gap-3 items-center">
                                                    <button disabled
                                                        class="btn btn-xs btn-circle btn-disabled relative z-10 !bg-[darkgrey]"><i
                                                            class="ri-shape-2-fill"></i></button>
                                                    <div class="">
                                                        <div class="inline-flex bg-white rounded-lg p-1">
                                                            <button
                                                                class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                                                data-tip="Video"
                                                                (click)="addStructureNode(3, 'video', parent.id, child.id, subchild.id)"><i
                                                                    class="ri-video-ai-line"></i></button>
                                                            <button
                                                                class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                                                data-tip="Test"><i
                                                                    class="ri-file-edit-line"></i></button>
                                                            <button
                                                            (click)="addStructureNode(3, 'certificate', parent.id, child.id, subchild.id)"
                                                                class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                                                data-tip="Certificate"><i
                                                                    class="ri-file-marked-line"></i></button>
                                                            <button
                                                                class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                                                data-tip="Badge"
                                                                (click)="addStructureNode(3, 'badge', parent.id, child.id, subchild.id)"><i
                                                                    class="ri-medal-line"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                }

                                            </div>
                                            }
                                        </li>
                                        }
                                        @if (child.structure_maps && isAllComponentsVisible) {
                                        <ul class="my-3 flex flex-col gap-5 pl-9" cdkDropList
                                            [cdkDropListData]="child?.structure_maps || []"
                                            (cdkDropListDropped)="structureMapDrop('child',{parentIndex,childIndex}, $event)">
                                        @for (structure_maps of child?.structure_maps;let childStructureMapsIndex =
                                        $index; track $index) {
                                        <ng-container [ngSwitch]="structure_maps?.action_type">

                                            <li class="pl-9" *ngSwitchCase="'video'" cdkDrag>
                                                <app-video-form (dataEvent)="emitData($event)" [data]="structure_maps"
                                                    [coursePublished]="coursePublished"
                                                    [index]="{'structureIndex':childStructureMapsIndex,'parentIndex':parentIndex,'childIndex':childIndex,'grandChildIndex':null}"></app-video-form>
                                            </li>
                                            <li class="pl-9" *ngSwitchCase="'document'" cdkDrag>
                                                <app-document-form></app-document-form>
                                            </li>
                                            <li class="pl-9" *ngSwitchCase="'certificate'" cdkDrag>
                                                <app-certificate-form (dataEvent)="emitData($event)"
                                                    [data]="structure_maps"
                                                    [coursePublished]="coursePublished"
                                                    [index]="{'structureIndex':childStructureMapsIndex,'parentIndex':parentIndex,'childIndex':childIndex,'grandChildIndex':null}"></app-certificate-form>
                                            </li>
                                            <li class="pl-9" *ngSwitchCase="'badge'" cdkDrag>
                                                <app-badge-form (dataEvent)="emitData($event)"
                                                    [data]="structure_maps"
                                                    [coursePublished]="coursePublished"
                                                    [index]="{'structureIndex':childStructureMapsIndex,'parentIndex':parentIndex,'childIndex':childIndex,'grandChildIndex':null}"></app-badge-form>
                                            </li>

                                        </ng-container>
                                        }
                                        </ul>
                                        }


                                    </ul>
                                </div>

                                @if (child?.flag !== 1) {

                                <div class="flex gap-3 items-center mt-10">
                                    <button class="btn btn-xs btn-circle btn-neutral"
                                        (click)="addNode(3, parent.id, child.id)"><i class="ri-add-line"></i></button>
                                    <div class="">
                                        <div class="inline-flex bg-white rounded-lg p-1">
                                            <button
                                                class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                                data-tip="Video"
                                                (click)="addStructureNode(2, 'video', parent.id, child.id, null)"><i
                                                    class="ri-video-ai-line"></i></button>
                                            <button
                                                class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                                data-tip="Test"><i class="ri-file-edit-line"></i></button>
                                            <button
                                                class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                                data-tip="Certitficate"
                                                (click)="addStructureNode(2, 'certificate', parent.id, child.id, null)"><i
                                                    class="ri-file-marked-line"></i></button>
                                            <button
                                                class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                                data-tip="Badge"
                                                (click)="addStructureNode(2, 'badge', parent.id, child.id, null)"><i
                                                    class="ri-medal-line"></i></button>
                                        </div>
                                    </div>
                                </div>
                                }

                            </div>
                            }
                        </li>
                        }

                        @if (parent.structure_maps && isAllComponentsVisible) {
                        <ul class="my-3 flex flex-col gap-5 pl-9" cdkDropList
                            [cdkDropListData]="parent?.structure_maps || []"
                            (cdkDropListDropped)="structureMapDrop('parent',{parentIndex}, $event)">
                        @for (structure_maps of parent?.structure_maps;let parentStructureMapsIndex = $index; track
                        $index) {
                        <ng-container [ngSwitch]="structure_maps?.action_type">

                            <li class="pl-9" *ngSwitchCase="'video'" cdkDrag>
                                <app-video-form (dataEvent)="emitData($event)" [data]="structure_maps"
                                    [coursePublished]="coursePublished"
                                    [index]="{'structureIndex':parentStructureMapsIndex,'parentIndex':parentIndex,'childIndex':null,'grandChildIndex':null}"></app-video-form>
                            </li>
                            <li class="pl-9" *ngSwitchCase="'document'" cdkDrag>
                                <app-document-form></app-document-form>
                            </li>
                            <li class="pl-9" *ngSwitchCase="'certificate'" cdkDrag>
                                <app-certificate-form (dataEvent)="emitData($event)"
                                    [data]="structure_maps"
                                    [coursePublished]="coursePublished"
                                    [index]="{'structureIndex':parentStructureMapsIndex,'parentIndex':parentIndex,'childIndex':null,'grandChildIndex':null}"></app-certificate-form>
                            </li>
                            <li class="pl-9" *ngSwitchCase="'badge'" cdkDrag>
                                <app-badge-form (dataEvent)="emitData($event)"
                                    [data]="structure_maps"
                                    [coursePublished]="coursePublished"
                                    [index]="{'structureIndex':parentStructureMapsIndex,'parentIndex':parentIndex,'childIndex':null,'grandChildIndex':null}"></app-badge-form>
                            </li>

                        </ng-container>
                        }
                        </ul>
                        }
                    </ul>
                </div>

                @if (parent?.flag !== 1) {
                <div class="flex gap-3 items-center mt-10">
                    <button class="btn btn-xs btn-circle btn-neutral" (click)="addNode(2, parent.id)"><i
                            class="ri-add-line"></i></button>
                    <div class="">
                        <div class="inline-flex bg-white rounded-lg p-1">
                            <button class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                data-tip="Video" (click)="addStructureNode(1, 'video', parent.id, null, null)"><i
                                    class="ri-video-ai-line"></i></button>
                            <button class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                data-tip="Test"><i class="ri-file-edit-line"></i></button>
                            <button class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                data-tip="Certitficate"
                                (click)="addStructureNode(1, 'certificate', parent.id, null, null)"><i
                                    class="ri-file-marked-line"></i></button>
                            <button class="tooltip btn border-none shadow-none bg-white btn-sm btn-square rounded"
                                data-tip="Badge"
                                (click)="addStructureNode(1, 'badge', parent.id, null, null)"><i
                                    class="ri-medal-line"></i></button>
                        </div>
                    </div>
                </div>
                }

            </div>
            }
        </li>
        }
    </ul>


</div>